export enum UserRoles {
    user = "user",
    trusted = "trusted",
    admin = "admin",
}
